import { gql } from "@apollo/client";

export const GET_PARENT_ASSIGNED_FORMS = gql`
  query GetParentAssignedForms($organization_id: uuid!) {
    assigned_form_next_form(
      where: {
        has_started: { _eq: false }
        assigned_form_template: {
          deleted_at: { _is_null: true }
          active: { _eq: true }
          enrollment_period: {
            deleted_at: { _is_null: true }
            organization_id: { _eq: $organization_id }
          }
        }
      }
    ) {
      assigned_form_id
      assigned_form_template {
        id
        name
      }
      person_id
      previous_form_id
      previous_offer_id
      previous_waitlist_id
    }
  }
`;

export const GET_PARENT_FORMS_INDEX = gql`
  query GetParentFormsIndex($organization_id: uuid!, $guardian_id: uuid!) {
    person(
      order_by: [{ last_name: asc }, { first_name: asc }, { birth_date: asc }]

      where: {
        organization_id: { _eq: $organization_id }
        person_type: { _eq: applicant }
        active: { _eq: true }
        _or: [
          {
            second_relationship: {
              _and: {
                active: { _eq: true }
                first_person: { _eq: $guardian_id }
              }
            }
          }
          {
            first_relationship: {
              _and: {
                active: { _eq: true }
                second_person: { _eq: $guardian_id }
              }
            }
          }
        ]
      }
    ) {
      id
      avatar
      birth_date
      first_name
      last_name

      forms(
        where: {
          form_template: {
            active: { _eq: true }
            enrollment_period: {
              _and: {
                active: { _eq: true }
                organization_id: { _eq: $organization_id }
              }
            }
          }
          _and: [{ status: { _neq: Deleted } }]
          _or: [
            { is_hidden_from_parent: { _eq: false } }
            { is_hidden_from_parent: { _is_null: true } }
          ]
        }
      ) {
        id
        status
        submitted_at

        previous_offer {
          school {
            id
            name
          }
        }

        previous_waitlist {
          school {
            id
            name
          }
        }

        action_items {
          id
          form_id
          summary
          status
          created_at
          updated_at
        }

        form_template {
          id
          key
          name
          closed_at
          open_at
          allow_form_deletion_by_family
          show_waitlist_position
          form_status_descriptions {
            description
            id
            status
          }

          enrollment_period {
            id
            name
            key
            active
          }

          sections {
            type
            schools_ranking_section {
              ranking_enabled
            }
            family_editable_statuses
          }
        }

        form_school_ranks(order_by: { rank: asc_nulls_last }) {
          id
          created_at
          rank
          updated_at

          school {
            id
            name
            reference_id
          }

          tags(order_by: { enrollment_period_tag: { name: asc } }) {
            id
            enrollment_period_tag {
              id
              name
              description
            }
          }
        }

        grades_answers {
          grade_config {
            label
          }
        }
      }
    }
  }
`;

export const GET_OFFERS_FORM_CONTEXT = gql`
  query GetOffersFormContext($form_id: uuid!) {
    form(where: { id: { _eq: $form_id }, deleted_at: { _is_null: true } }) {
      id
      form_template_id
      person {
        first_name
      }
      form_template {
        key
        enrollment_period {
          name
          key
        }
        sections(where: { type: { _eq: SchoolRankingSection } }) {
          schools_ranking_section {
            ranking_enabled
          }
        }
      }
      form_school_ranks(order_by: { rank: asc_nulls_last }) {
        rank
        school {
          id
          name
          reference_id
        }
      }
    }
  }
`;

export const SCHOOLS_BY_SCHOOL_REFERENCE_IDS = gql`
  query SchoolsBySchoolReferenceIDs(
    $school_reference_ids: [String!]
    $organization_id: uuid!
  ) {
    school(
      where: {
        reference_id: { _in: $school_reference_ids }
        organization_id: { _eq: $organization_id }
      }
    ) {
      id
      reference_id
      name
    }
  }
`;
